import { EmployeeEditTab } from '@/common/types';
import type { DashboardPerformanceReview } from '../../types';
import { DashboardSection } from '../DashboardSection';
import { PerformanceReviewTable } from './PerformanceReviewTable';

interface Props {
  className?: string;
  employeeId?: string;
  loading: boolean;
  performanceReviews: Array<DashboardPerformanceReview> | undefined;
  showPeriodFilter: boolean;
  title: string;
  withName: boolean;
}

export const PerformanceReview = ({
  className,
  employeeId,
  loading,
  performanceReviews,
  showPeriodFilter,
  title,
  withName,
}: Props) => (
  <DashboardSection
    className={className}
    link={employeeId && `/employees/edit/${employeeId}/${EmployeeEditTab.PERFORMANCE_REVIEW}`}
    linkTitle="View all"
    title={title}
  >
    <PerformanceReviewTable
      data={performanceReviews ?? []}
      loading={loading}
      showPeriodFilter={showPeriodFilter}
      withName={withName}
    />
  </DashboardSection>
);
